import React, {Component} from 'react';
import SimpleDataTable from "../common/SimpleDataTable";
import {Col, Row} from "antd";
import {Translation} from "react-i18next";
import utils from "../../common/utils";
import {connect} from "react-redux";

class OrderBook extends Component {
  columns = (t) => [
    {
      title: t('exchange.order_book.price'),
      width: 150,
      dataIndex: 'price',
      key: 'price',
      render: (price) => utils.specialFormatJsx(price)
    },
    {
      title: t('exchange.order_book.amount'),
      width: 150,
      dataIndex: 'quantity',
      key: 'quantity',
      render: (quantity) => utils.specialFormatJsx(quantity)
    },
    {
      title: t('exchange.order_book.total'),
      width: 150,
      dataIndex: 'total',
      key: 'total',
      render: (total) => utils.specialFormatJsx(total)
    },
    {
      title: t('exchange.order_book.sum'),
      width: 250,
      dataIndex: 'sum',
      key: 'sum',
      style: {
        textAlign: 'right',
        paddingRight: 10,
      },
      headerStyle: {
        textAlign: 'right',
        paddingRight: 10,
      },
      render: (sum) => utils.specialFormatJsx(sum)
    },
  ];
  
  columnsReverse = (t) => [
    {
      title: t('exchange.order_book.sum'),
      width: 250,
      dataIndex: 'sum',
      key: 'sum',
      style: {
        textAlign: 'left',
        paddingLeft: 10,
      },
      headerStyle: {
        textAlign: 'left',
        paddingLeft: 10,
      },
      render: (sum) => utils.specialFormatJsx(sum)
    },
    {
      title: t('exchange.order_book.total'),
      width: 150,
      dataIndex: 'total',
      key: 'total',
      render: (total) => utils.specialFormatJsx(total)
    },
    {
      title: t('exchange.order_book.amount'),
      width: 150,
      dataIndex: 'quantity',
      key: 'quantity',
      render: (quantity) => utils.specialFormatJsx(quantity)
    },
    {
      title: t('exchange.order_book.price'),
      width: 150,
      dataIndex: 'price',
      key: 'price',
      render: (price) => utils.specialFormatJsx(price)
    },
  ];
  
  constructor(props) {
    super(props);
    this.onClickTrBuy = this.onClickTrBuy.bind(this);
    this.onClickTrSell = this.onClickTrSell.bind(this);
  }
  
  componentDidMount() {
    const self = this;
    self.props.onFetchAllOrderBookAction({
      coin: this.props.coin,
      currency: this.props.currency,
    });
  }
  
  onClickTrBuy(event, item) {
    this.props.onClickOrderBookBuy({...item})
    this.props.orderClick('Buy');
  }
  
  onClickTrSell(event, item) {
    this.props.onClickOrderBookSell({...item});
    this.props.orderClick('Sell');
  }
  
  showTooltip = ({price, quantity, total, sum}) => <div className={'order-book-tooltip'}>
    <div className={'clearfix'}>
      <div className={'fll mr-medium'}>
        {window.$t('exchange.order_book.price')}
      </div>
      <div className={'flr'}>
        {price} {this.props.currency}
      </div>
    </div>
    <div className={'clearfix'}>
      <div className={'fll mr-medium'}>
        {window.$t('exchange.order_book.amount')}
      </div>
      <div className={'flr'}>
        {quantity} {this.props.coin}
      </div>
    </div>
    <div className={'clearfix'}>
      <div className={'fll mr-medium'}>
        {window.$t('exchange.order_book.total')}
      </div>
      <div className={'flr'}>
        {total} {this.props.currency}
      </div>
    </div>
    <div className={'clearfix'}>
      <div className={'fll mr-medium'}>
        {window.$t('exchange.order_book.sum')}
      </div>
      <div className={'flr'}>
        {sum} {this.props.currency}
      </div>
    </div>
  </div>
  
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextProps.currency !== this.props.currency || this.props.coin !== nextProps.coin;
  }
  
  render() {
    // console.log("render OrderBook");
    return (
      <Translation>
        {(t) => <div className="order-book-wrap">
          <Row className="full-height scroll scroll-0">
            <Col span={12} className="full-height">
              <BuyOrderBookContainer columns={this.columnsReverse(t)}
                                     showTooltip={this.showTooltip}
                                     isAnimated={true}
                                     onClickTr={this.onClickTrBuy} scroll={true} className="order-buy full-height"/>
            </Col>
            <Col span={12} className="full-height">
              <SellOrderBookContainer columns={this.columns(t)}
                                      showTooltip={this.showTooltip}
                                      isAnimated={true}
                                      onClickTr={this.onClickTrSell} scroll={true} className="order-sell full-height"/>
            </Col>
          </Row>
        </div>}
      </Translation>
    );
  }
}

class BuyOrderBook extends Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return utils.hash(this.props.buyOrderBooks) !== utils.hash(nextProps.buyOrderBooks);
  }
  
  render() {
    // console.log("== render BuyOrderBook")
    return <Translation>
      {t => <SimpleDataTable {...this.props} data={this.props.buyOrderBooks}/>}
    </Translation>
  }
}

class SellOrderBook extends Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return utils.hash(this.props.sellOrderBooks) !== utils.hash(nextProps.sellOrderBooks);
  }
  
  render() {
    // console.log("== render SellOrderBook")
    return <Translation>
      {t => <SimpleDataTable {...this.props} data={this.props.sellOrderBooks}/>}
    </Translation>
  }
}

const mapStateToPropsBuy = (state) => ({
  buyOrderBooks: state.orderBook.buyOrderBooks,
});

const mapStateToPropsSell = (state) => ({
  sellOrderBooks: state.orderBook.sellOrderBooks
});

const BuyOrderBookContainer = connect(mapStateToPropsBuy, null)(BuyOrderBook);
const SellOrderBookContainer = connect(mapStateToPropsSell, null)(SellOrderBook);


export default OrderBook;
